import type { CentralFetcher } from '@bb-dev123/central-billing';
import { authFetch } from './authFetch';

/**
 * Central's own `CentralFetcher` (the shared @bb-dev123/central-billing
 * transport shape) over `authFetch` — same-origin `/api`, Bearer token. Never
 * throws: a network failure resolves `{ status: 0, body: { code: 'NETWORK_ERROR' } }`.
 * Lets Central's pages use the SAME typed billing client every app uses.
 */
export function centralFetcher(authToken: string): CentralFetcher {
  return async (path, init) => {
    try {
      const hasBody = init?.body !== undefined;
      const res = await authFetch(path, authToken, {
        method: init?.method ?? 'GET',
        ...(hasBody ? { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(init!.body) } : {}),
        ...(init?.signal ? { signal: init.signal } : {}),
      });
      const body = await res.json().catch(() => null);
      return { status: typeof res.status === 'number' ? res.status : res.ok ? 200 : 500, body };
    } catch {
      return { status: 0, body: { ok: false, code: 'NETWORK_ERROR', error: 'Network error' } };
    }
  };
}
